import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown';
import Placeholder from '@tiptap/extension-placeholder'

export function _loadTipTap(container) {
  return function() {
    return new Editor({
      element: container,
      extensions: [
        StarterKit,
        Markdown,
        Placeholder.configure({
          placeholder: 'Write your thoughts...',
        }),
      ],
      editorProps: {
        attributes: {
          class: 'prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl focus:outline-none',
        },
      }
    });
  }
}

export function _toggleBold(editor) {
  return function() {
    editor.chain().focus().toggleBold().run();
  }
}

export function _toggleItalic(editor) {
  return function() {
    editor.chain().focus().toggleItalic().run();
  }
}

export function _getMarkdown(editor) {
  return function() {
    return editor.storage.markdown.getMarkdown();
  }
}
